import { defineStore } from 'pinia'

import type { DisciplineStore } from '@stores/discipline/interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useDisciplineStore = defineStore('discipline', {
  state: (): DisciplineStore => ({
    _hydrated: false,
    activeDiscipline: null,
    mathLanding: false,
    elaLanding: false,
    disciplineInfoMath: null,
    disciplineInfoEla: null,
    modalTutorProfile: false,
    disciplineScheduleShow: true, // TODO: FEATURE FLAG for Schedule
  }),
  actions,
  getters,
})
